(function ($, Drupal) {
  Drupal.behaviors.NewsletterPanelV2 = {
    attach: function (context) {

      function runThisIt () {

        const els = once('с-newsletter-panel-v2', '.с-newsletter-panel-v2', context)
          .filter(function (el) {
            return !el.classList.contains('component-product-tile-set');
          });


        els.forEach(function (el) {
          const $el = $(el);
          const leftPaws = $el.find('.newsletter-panel-v2--left-paws .paw-1');
          const rightPaws = $el.find('.newsletter-panel-v2--right-paws .paw-1');

          function initSlickOnlyOptionB (boxItems) {

            if (window.matchMedia('(min-width: 0px) and (max-width: 1140px)').matches) {

              // Mobile
              boxItems.slick({
                arrows: false,
                centerMode: true,
                centerPadding: '98px',
                slidesToShow: 1
              });

            }
            else {

              // Desktop
            }

          }

          const variantB = $el.find('.newsletter-panel-v2-variant-b');

          function showCatAndDogPaws () {
            if (leftPaws.length) {
              leftPaws[0].classList.add('dog');
              rightPaws[0].classList.add('cat', 'cat-for-better-together');
              if (variantB.length) {
                const boxItems = $el.find('.cat-and-dog-box-wrapper');
                initSlickOnlyOptionB(boxItems);
              }
            }

            const locationSelect = $el.find('.pet-type-dog-and-cat-wrapper');
            locationSelect[0].style.display = 'block';
          }
          function showDogPaws () {
            if (leftPaws.length) {
              leftPaws[0].classList.add('dog');
              rightPaws[0].classList.add('dog');
              if (variantB.length) {
                const boxItems = $el.find('.dog-box-wrapper');
                initSlickOnlyOptionB(boxItems);
              }
            }
            const locationSelect = $el.find('.pet-type-dog-wrapper');
            locationSelect[0].style.display = 'block';
          }
          function showCatPaws () {
            if (leftPaws.length) {
              leftPaws[0].classList.add('cat');
              rightPaws[0].classList.add('cat');
              if (variantB.length) {
                const boxItems = $el.find('.cat-box-wrapper');
                initSlickOnlyOptionB(boxItems);
              }
            }

            const locationSelect = $el.find('.pet-type-cat-wrapper');
            locationSelect[0].style.display = 'block';
          }

          let nameTerm;
          const locationSelect = $el.find('.field--name-field-newsletter-panel-v2-setpet');
          if (locationSelect.length) {
            nameTerm = locationSelect[0].innerHTML;
          } if (nameTerm === 'automatically' ) {

            // need work...
          }

          if (nameTerm) {

            const regexListDog = [/dog/, /puppy/, /dogs/ ];
            const isMatchDog = regexListDog.some(function (rx) {
              return rx.test(nameTerm.toLowerCase());
            });

            // Dog
            if (isMatchDog) {
              showDogPaws();
            }

            const regexListCat = [/cat/, /kitten/, /cats/ ];
            const isMatchCat = regexListCat.some(function (rx) {
              return rx.test(nameTerm.toLowerCase());
            });

            // Cat
            if (isMatchCat) {
              showCatPaws();
            }

            // Dog and Cat
            if (!isMatchDog && !isMatchCat) {
              showCatAndDogPaws();
            }

          }
          else {
            showCatAndDogPaws();
          }
        });
      }

      runThisIt();
      $(document).ajaxComplete(function () {
        runThisIt();
      });

    }
  };
})(jQuery, Drupal);
